
	function PublicLoginForm(settings){

		this.name = "login";

		this.data = {
			pages: [
				{
					name: "form",
					errors: {
						general: "There are errors in your submission, please correct before continuing.",
						not_found: "Please check your Licence Number and Pin."
					},
					submissionUrl: "/forms/login",
					submissionText: "Logging you in...",
					static: true,
					onRender: $wrapper => {
						$wrapper.css("min-height",$wrapper.height()); //Set a min height to avoid a bit of jumpyness when changing page
						setTimeout(e => {
							$wrapper.find("input:text:visible:first").focus().trigger("focus");
						},1000)
					}
				},
				{
					title: "Success",
					name: "logged-in",
					onRender: e => {
						const state = nav.getState();
						const fwd = state.nextParams['fwd'];
						//nav.change(fwd ? fwd : "/contact/"); //Example... where to?
						//We'll make this a hard redirect, not a nav.change so that we don't have to play silly buggers with invalidation js caches
						document.location.href = fwd ? fwd : "/hub/"; //Example... where to?;
					},
					static: true

				},
			]
		}

		this.setup(settings);
	};
	PublicLoginForm.inheritsFrom( PageForm );

